import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('PRODUCTS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class ProductsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'products' como el nombre del recurso a la clase base
    super('products');
    log.debug('Servicio de Productos inicializado');
  }

}
